import { Outlet } from "react-router-dom";
import "./Reports.css";
import { Panel } from "rsuite";
import { useTranslation } from "react-i18next";

const Reports = () => {
  const [t] = useTranslation();
  return (
    <Panel header={t("reports-all.reports")} className="content content-final h-100">
      <Outlet />
    </Panel>
  );
};

export default Reports;
